module.exports = "../static/media/official.cd4b743e.png";